export const NOTIFICATION_SHOW_TIMER = 10; //seconds
export const DEFAULT_MAX_LEVERAGE = 25;
export const DEFAULT_MAKER_BASIS_POINTS = 2;
export const DEFAULT_TAKER_BASIS_POINTS = 6;
